module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"searchButton":"search","clearButton":"clear","latitudeName":"lat","longitudeName":"lng"},"message":{"progress":"processing..."}},"ja":{"label":{"searchButton":"検索","clearButton":"クリア","latitudeName":"緯度","longitudeName":"経度"},"message":{"progress":"処理中…"}}}')
  delete Component.options._Ctor
}
